// One image per service, numbered in page order (01–20), from public/images/services.
// Used by the services page and the home page services deck.
// Previous photo links: content/previousImages.js
const serviceImageBase = `${process.env.PUBLIC_URL}/images/services`;

export const serviceImages = [
  '1.jfif',
  '2.jfif',
  '3.png',
  '4.png',
  '5.jfif',
  '6.jfif',
  '7.jfif',
  '8.jfif',
  '9.jfif',
  '10.jfif',
  '11.jfif',
  '12.jfif',
  '13.jfif',
  '14.jfif',
  '15.jfif',
  '16.jfif',
  '17.jfif',
  '18.jfif',
  '19.jfif',
  '20.jfif',
].map((file) => `${serviceImageBase}/${file}`);

// Image for a service by its catalogue number ('01' to '20').
export const serviceImageFor = (id) => serviceImages[Number(id) - 1] || serviceImages[0];

// Near-square photos: cropped to their box (keeping the top) instead of stretched into it.
export const croppedServiceImages = new Set([`${serviceImageBase}/3.png`]);
